import { useMemo } from 'react';
import { useAuthStore } from '../store';
import { filterAuthorizedNavigationItems, filterAuthorizedServices, hasAnyPermission } from '../utils/authorization';
import type { EmbeddedService, NavigationItem } from '@/types';

export const useAuthorization = () => {
  const user = useAuthStore((state) => state.user);

  return useMemo(() => ({
    user,
    hasAnyPermission: (requiredPermissions?: string[]) => hasAnyPermission(user, requiredPermissions),
    filterNavigationItems: (items: NavigationItem[]) => filterAuthorizedNavigationItems(items, user),
    filterServices: (services: EmbeddedService[]) => filterAuthorizedServices(services, user),
  }), [user]);
};
